var e = function e() {
  return "undefined" != typeof window;
},
    n = function n() {
  return e() && "ontouchstart" in window;
},
    t = function t(e) {
  return String(e).replace(/\s/g, "-").toLowerCase();
},
    o = function o(e) {
  var n = null;

  try {
    n = JSON.parse(e);
  } catch (e) {
    "development" === process.env.NODE_ENV && console.warn("Catch exception on parse value with JSON.parse:", e);
  }

  return n;
};

export { e as isBrowser, n as isTouchDevice, o as parsedJsonOrNull, t as prepareClassName };